import React from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

function KskMarkdown({ markdown = "", className}) {
  const html = DOMPurify.sanitize(marked.parseInline(markdown));
  return <span className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default React.memo(KskMarkdown);